import BaseModelAPI from '../BaseModelAPI';

export default class MetodeQcList extends BaseModelAPI {

	static entity = 'metodeqclist'
	static entityName = 'metodeqc';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
